import { KoobInputStepper } from '../../components';
import { SubLabel } from './SubLabel';
import type { GroupSizeFieldProps } from './types';

export type { GroupSizeFieldProps };

export function GroupSizeField({
  adults,
  childrenCount,
  onAdultsChange,
  onChildrenCountChange,
  t,
}: GroupSizeFieldProps) {
  return (
    <div className="flex flex-wrap items-start gap-8">
      <div>
        <SubLabel>{t('travellers.adults')}</SubLabel>
        <div className="flex items-center gap-3">
          <KoobInputStepper
            value={adults}
            onValueChange={onAdultsChange}
            min={1}
          />
          <span className="text-sm text-gray-400">
            {t('travellers.adultsHint')}
          </span>
        </div>
      </div>
      <div>
        <SubLabel>{t('travellers.children')}</SubLabel>
        <div className="flex items-center gap-3">
          <KoobInputStepper
            value={childrenCount}
            onValueChange={onChildrenCountChange}
            min={0}
          />
          <span className="text-sm text-gray-400">
            {t('travellers.childrenHint')}
          </span>
        </div>
      </div>
    </div>
  );
}
